import React from 'react';
import { loader } from 'graphql.macro';
import { RouteComponentProps, useParams } from '@reach/router';
import { useQuery } from 'react-apollo';

import { useGpaRedirect } from '../../util/hooks/useGpaRedirect';
import useFeatureFlag from '../../util/hooks/useFeatureFlag';
import AlertLoader from '../../components/gpaCancelPolicy/AlertLoader';
import QuotesPage from './QuotesPage';

import {
  BigBoldText,
  ErrorBox,
  OuterBoxx,
  SmallText
} from './QuotesPageStyles';

import NoPolicyorAccount from '../../assets/images/No_policies.png';

import {
  GET_QUOTES_LIST_FROM_PC_getQuotesInformation_quotesList,
  GET_QUOTES_LIST_FROM_PCVariables
} from './graphql/__generated__/GET_QUOTES_LIST_FROM_PC';

const GET_QUOTES_LIST_FROM_PC = loader('./graphql/Get_Quote_List.graphql');

const excludeStatuses = ['expired', 'issued', 'withdrawn', 'not taken'];

export default (_: RouteComponentProps) => {
  const { accountNumber, lob: sourceSystem } = useParams();

  const { flagDetails: redirectToGpa } = useFeatureFlag('RedirectToGPA');
  useGpaRedirect({
    autoRedirect: true,
    featureFlag: redirectToGpa?.enabled,
    accountNumber
  });

  const { loading, error, data } = useQuery(GET_QUOTES_LIST_FROM_PC, {
    variables: {
      accountNumber,
      sourceSystem
    } as GET_QUOTES_LIST_FROM_PCVariables,
    fetchPolicy: 'cache-and-network'
  });

  if (loading) return <AlertLoader message="Getting Quotes List" />;

  if (error || !data?.getQuotesInformation) {
    return (
      <ErrorBox>
        <OuterBoxx>
          <img
            height="250px"
            width="250px"
            src={NoPolicyorAccount}
            alt="No Open Quotes Exists"
          />
          <BigBoldText>
            No Open Quotes Available for Account {accountNumber}
          </BigBoldText>
          <SmallText>If a quote was just opened, check back shortly!</SmallText>
        </OuterBoxx>
      </ErrorBox>
    );
  }

  const quotesList = data.getQuotesInformation.quotesList || [];

  const filteredQuotes = quotesList.filter(
    (quote: GET_QUOTES_LIST_FROM_PC_getQuotesInformation_quotesList) =>
      quote.status && !excludeStatuses.includes(quote.status.toLowerCase())
  );

  return (
      <QuotesPage quotesList={filteredQuotes} __typename="quotesInfoResponse" />
  );
};
